import React from 'react'

import { AppRefreshContext, type AppRefresh } from 'context/AppRefreshContext'

export default function useAppRefresh(): AppRefresh {
  return React.useContext(AppRefreshContext)
}
